
// src/web/components/user-password-panel.jsx

import React from 'react'
import connect from '../../connects/user-password-panel'
import {
  Input,
} from 'react-toolbox/lib/input'
import {
  Card,
  CardText,
  CardActions,
} from 'react-toolbox/lib/card'
import {
  Button
} from 'react-toolbox/lib/button'
import {
  linkUI
} from '../../helpers/form-validator'
import theme from './themes/flat-card.css'

class UserPasswordPanel extends React.Component {
  render() {
    const {
      t,
      ui,
      isPasswordUpdating,
      updateUI,
      validateAndSubmit,
    } = this.props

    return (
      <Card theme={theme}>
        <form onSubmit={(e) => validateAndSubmit(this.props, e)}>
          <CardText>
            <normal><strong>{t('label:現在のパスワード')}</strong></normal>
            <Input name="currentPassword" required
              label={t('label:現在のパスワード')}
              value={ui.currentPassword}
              icon='lock_open'
              type='password'
              error={ui.currentPasswordError && t('error:パスワードを入力してください')}
              onChange={linkUI(this, 'currentPassword')}
              type='password' />
          </CardText>

          <CardText>
            <normal><strong>{t('label:新しいパスワード')}</strong></normal>
            <Input name="newPassword" required
              label={t('label:新しいパスワード')}
              value={ui.newPassword}
              icon='lock_open'
              type='password'
              error={ui.newPasswordError && t('error:パスワードを入力してください')}
              onChange={linkUI(this, 'newPassword')} />

            <Input name="confirmNewPassword" required
              label={t('label:新しいパスワード(再入力)')}
              value={ui.confirmNewPassword}
              icon='lock_open'
              type='password'
              error={ui.confirmNewPasswordError && t('error:パスワードを入力してください')}
              onChange={linkUI(this, 'confirmNewPassword')} />
          </CardText>

          <CardActions>
            <Button raised primary
              disabled={isPasswordUpdating}
              type="submit"
              style={{ width: '100%' }}
              label={t('label:更新')} />
          </CardActions>
        </form>
      </Card>
    )
  }
}

export const RawUserPasswordPanel = UserPasswordPanel
export default connect(UserPasswordPanel)



// WEBPACK FOOTER //
// ./src/web/components/user-password-panel.jsx